import { useEffect, useState } from 'react';
import { apiService } from '@/services/api';

interface SiteBranding {
  logoUrl?: string;
  faviconUrl?: string;
}

export function useSiteBranding(): SiteBranding {
  const [branding, setBranding] = useState<SiteBranding>({});

  useEffect(() => {
    void apiService.seoSettings.get()
      .then(res => {
        if (res.data) {
          setBranding(res.data);
          if (res.data.faviconUrl) {
            const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
            if (link) link.href = res.data.faviconUrl;
          }
        }
      })
      .catch(() => {});
  }, []);

  return branding;
}
